import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { IconButton, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ErrorIcon from "@mui/icons-material/Error";
import { toastMessage } from "../../utils/toastMessage";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import {
  getConsultantKPIApi,
  getConsultantKPIDetailApi,
} from "../../services/consultantManagement";
import Loader from "../../comman/Loader";
import { dateFormat, formatDuration } from "../../utils/dateFormat";
import Pagination from "react-js-pagination";
import { getUserMasterSettingsApi } from "../../services/dashboard";
import { DatePicker } from "../../components/Form";
import findSerialNumber from "../../utils/findSerialNumber";
import { CapitalizeFirstWord } from "../../utils/CapitalizeFirstWord";
import { user } from "../../routes/route";
import ConsultantOnlineTime from "./ConsultantOnlineTime";

// Circular Progress Component
const CircularProgressKPI = ({ value, percentage, status, title, onClick, kpiType, total, showDangerIcon }) => {
  // Status-based colors for performance (Green/Orange/Red)
  const statusColors = {
    good: "#4caf50", // Green
    average: "#ff9800", // Orange
    poor: "#f44336", // Red
  };

  // Distinct background colors for each KPI type
  const kpiBgColors = {
    missedOpportunities: "#ffebee", // Light pink/red
    paidConversion: "#e3f2fd", // Light blue
    onlineTime: "#f3e5f5", // Light purple
    todayOnlineTime: "#f3e5f5", // Light purple
  };

  // Distinct border colors for each KPI type
  const kpiBorderColors = {
    missedOpportunities: "#e91e63", // Pink
    paidConversion: "#2196f3", // Blue
    onlineTime: "#9c27b0", // Purple
    todayOnlineTime: "#9c27b0", // Purple
  };

  const progressColor = statusColors[status] || "#9e9e9e";
  const bgColor = kpiBgColors[kpiType] || "#f5f5f5";
  const borderColor = kpiBorderColors[kpiType] || "#9e9e9e";

  // Calculate stroke-dasharray and stroke-dashoffset for the arc
  const radius = 90;
  const circumference = 2 * Math.PI * radius;
 
  const offset = circumference - (percentage / 100) * circumference;
  console.log(kpiType, "kpiType");
  console.log(circumference, "circumference");
  console.log(offset, "offset");
  console.log(percentage, "percentage");

  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        transition: "all 0.3s ease",
        padding: "30px",
        borderRadius: "20px",
        backgroundColor: bgColor,
        boxShadow: `0 4px 16px ${borderColor}30`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.08)";
        e.currentTarget.style.boxShadow = `0 8px 24px ${borderColor}50`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = `0 4px 16px ${borderColor}30`;
      }}
    >
      <div style={{ position: "relative", marginBottom: "20px" }}>
        <svg width="220" height="220" style={{ transform: "rotate(-90deg)", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))" }}>
          {/* Background circle */}
          <circle
            cx="110"
            cy="110"
            r={radius}
            fill="none"
            stroke="#e0e0e0"
            strokeWidth="14"
          />
          {/* Progress arc - uses status color (Green/Orange/Red) */}
          <circle
            cx="110"
            cy="110"
            r={radius}
            fill="none"
            stroke={borderColor}
            strokeWidth="14"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{
              transition: "stroke-dashoffset 0.8s ease-in-out",
            }}
          />
        </svg>
        {/* Center content */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            borderRadius: "50%",
            width: "180px",
            height: "180px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            border: `4px solid white`,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "2px",
              width: "100%",
            }}
          >
            {total !== undefined && total !== null ? (
              <>
                <span
                  style={{
                    fontSize: "35px",
                    fontWeight: "bold",
                    color: borderColor,
                    lineHeight: "1",
                    textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  {value}
                </span>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "normal",
                    color: "#666",
                    opacity: 0.6,
                    lineHeight: "1",
                  }}
                >
                  / {total}
                </span>
              </>
            ) : (
              <span
                style={{
                  fontSize: "40px",
                  fontWeight: "bold",
                  color: borderColor,
                  lineHeight: "1",
                  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                {value}
              </span>
            )}
          </div>
        </div>
      </div>
      <h4
        style={{
          margin: 0,
          fontSize: "18px",
          fontWeight: "600",
          color: borderColor,
          textAlign: "center",
          textShadow: "0 1px 2px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        {title}
        {showDangerIcon && (
          <ErrorIcon 
            style={{ 
              color: "#f44336", 
              fontSize: "24px",
              animation: "pulse 2s infinite"
            }} 
          />
        )}
      </h4>
      <div
        style={{
          marginTop: "8px",
          padding: "6px 12px",
          borderRadius: "12px",
          backgroundColor: progressColor,
          color: "white",
          fontSize: "12px",
          fontWeight: "600",
          textTransform: "uppercase",
        }}
      >
        {status === "good" ? "Good" : status === "average" ? "Average" : "Poor"}
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.7;
            transform: scale(1.1);
          }
        }
      `}</style>
    </div>
  );
};

const ConsultantKPI = () => {
  const { id: consultantId, name } = useParams();
  const consultantName = name || "Consultant";
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [selectedKPI, setSelectedKPI] = useState(null);
  const [kpiDetailData, setKpiDetailData] = useState(null);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [tableData, setTableData] = useState([]);
  const { USER_DETAIL, USER_DELETE } = user;

  // Date filter state
  const [dateFilter, setDateFilter] = useState("last7days");
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);

  // KPI Target Settings (dynamic thresholds) - defaults
  const defaultKpiTargets = {
    missedOpportunities: {
      good: 0,
      average: 5,
      poor: 6
    },
    paidConversion: {
      good: 35,
      average: 20,
      poor: 0
    },
    onlineTime: {
      good: 80,
      average: 50,
      poor: 0
    }
  };

  const [kpiTargets, setKpiTargets] = useState();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalFilteredItems, setTotalFilteredItems] = useState(0);
  const [searchFilter, setSearchFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [conversionFilter, setConversionFilter] = useState("all");

  // KPI data state
  const [kpiData, setKpiData] = useState({
    missedOpportunities: {
      total:0,
      value: 0,
      status: "poor",
      message: "",
    },
    paidConversion: {
      value: 0,
      status: "poor",
      message: "",
    },
    onlineTime: {
      value: 0,
      target: 0,
      status: "poor",
      message: "",
    },
    todayOnlineTime: {
      value: 0,
      target: 0,
      status: "poor",
      message: "",
    },
  });

  // Date filter options
  const dateFilterOptions = [
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last21days", label: "21 Days" },
    { value: "last90days", label: "90 Days" },
    { value: "thisMonth", label: "This Month" },
    // { value: "custom", label: "Custom Range" },
  ];

  // Helper function to get date range based on filter
  const getDateRange = (filter) => {
    // Handle custom date range
    if (filter === "custom" && customStartDate && customEndDate) {
      const start = new Date(customStartDate);
      start.setUTCHours(0, 0, 0, 0);
      const end = new Date(customEndDate);
      end.setUTCHours(23, 59, 59, 999);
      return {
        startDate: start.toISOString(),
        endDate: end.toISOString(),
      };
    }

    const today = new Date();
    today.setUTCHours(23, 59, 59, 999);
    const start = new Date();
    start.setUTCHours(0, 0, 0, 0);

    switch (filter) {
      case "yesterday":
        start.setDate(start.getDate() - 1);
        today.setDate(today.getDate() - 1);
        break;
      case "last7days":
        start.setDate(start.getDate() - 7);
        break;
      case "last21days":
        start.setDate(start.getDate() - 21);
        break;
      case "last90days":
        start.setDate(start.getDate() - 90);
        break;
      case "thisMonth":
        start.setDate(1);
        break;
      case "lastMonth":
        start.setMonth(start.getMonth() - 1);
        start.setDate(1);
        const lastDay = new Date(start.getFullYear(), start.getMonth() + 1, 0);
        today.setDate(lastDay.getDate());
        today.setMonth(start.getMonth());
        break;
      default:
        start.setDate(start.getDate() - 7);
    }

    return {
      startDate: start.toISOString(),
      endDate: today.toISOString(),
    };
  };

  // Fetch KPI targets from settings (dynamic)
  const fetchKPITargets = async () => {
    try {
      const { data: _response } = await getUserMasterSettingsApi('kpiTargetSettings');

      if (_response?.data) {
        
        // Merge with defaults to ensure all fields are present
        const settingsData = _response.data;
        console.log(settingsData, "settingsData");
        setKpiTargets({
          missedOpportunities: settingsData.missedOpportunities,
          paidConversion: settingsData.paidConversion,
          onlineTime: settingsData.onlineTime,
        });
      } else {
        // Use defaults if no settings found
        // setKpiTargets(defaultKpiTargets);
      }
    } catch (error) {
      console.error('Error fetching KPI target settings:', error);
      // Use defaults on error
      // setKpiTargets(defaultKpiTargets);
    }
  };

  // Fetch KPI data - status calculations use dynamic targets from settings
  const fetchKPIData = async () => {
    try {
      showLoader();
      const dateRange = getDateRange(dateFilter);
      const { data } = await getConsultantKPIApi({
        consultantId,
        ...dateRange,
      });

      if (data?.code === 200) {
        const result = data.result || {};
        // Calculate KPI statuses using dynamic targets from settings
        setKpiData({
          missedOpportunities: {
            total: result.totalCallAttempts || 0,
            value: result.missedOpportunities || 0,
            target: kpiTargets.missedOpportunities.poor,
            status: getStatusForMissedOpportunities(result.missedOpportunities || 0),
            percentage: getMissedOpportunityPercentage(result.missedOpportunities || 0, kpiTargets.missedOpportunities).achievedPercentage,
            message: getMessageForMissedOpportunities(result.missedOpportunities || 0),
          },
          paidConversion: {
            value: result.paidConversion || 0,
            target: kpiTargets.paidConversion.poor,
            status: getStatusForPercentage(
              result.paidConversion || 0,
              kpiTargets.paidConversion.average,
              kpiTargets.paidConversion.good
            ),
            
            percentage: getPaidConversionPercentage(result.paidConversion || 0, kpiTargets.paidConversion).achievedPercentage,
            message: getMessageForPercentage(
              result.paidConversion || 0,
              kpiTargets.paidConversion.average,
              kpiTargets.paidConversion.good
            ),
          },
          onlineTime: {
            value: result.onlineTime || 0,
            target: result.totalTargetHours || 0,
            target: kpiTargets.onlineTime.poor,
            percentage: getOnlineTimePercentage(result.onlineTime || 0, result.totalTargetHours || 0, kpiTargets.onlineTime).achievedPercentage,
            status: getStatusForOnlineTime(
              result.onlineTime || 0,
              result.totalTargetHours || 0
            ),
            message: getMessageForOnlineTime(
              result.onlineTime || 0,
              result.totalTargetHours || 0
            ),
          },
          todayOnlineTime: {  
            value: result.todayOnlineTime || 0,
            total: result.dailyHourTarget || 0,
            target: kpiTargets.onlineTime.poor,
            percentage: getOnlineTimePercentage(result.todayOnlineTime || 0, result.dailyHourTarget || 0, kpiTargets.onlineTime).achievedPercentage,
            status: getStatusForOnlineTime(
              result.todayOnlineTime || 0,
              result.dailyHourTarget || 0
            ),
            message: getMessageForOnlineTime(
              result.todayOnlineTime || 0,
              result.dailyHourTarget || 0
            ),
          },
        });
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      toastMessage("Failed to fetch KPI data", "error");
    } finally {
      hideLoader();
    }
  };

  // Fetch KPI detail
  const fetchKPIDetail = async (kpiType, pageNum = 1) => {
    try {
      setLoadingDetail(true);
      const dateRange = getDateRange(dateFilter);
      const { data } = await getConsultantKPIDetailApi({
        consultantId,
        kpiType,
        ...dateRange,
        page: pageNum,
        limit: pageLimit,
      });

      if (data?.code === 200) {
        const result = data.result || {};
        let formattedData = [];

        if (kpiType === "missedOpportunities") {
          formattedData = (result.entries || []);
        } else if (kpiType === "paidConversion") {
          formattedData = (result.entries || [])
        } else if (kpiType === "onlineTime") {
          formattedData = (result.entries || [])
        } else if (kpiType === "todayOnlineTime") {
          formattedData = (result.entries || []);
        }

        setTableData(formattedData);
        setKpiDetailData(result);
        // Store pagination info
        if (result.pagination) {
          setTotalFilteredItems(result.pagination.total);
        }
      }
    } catch (error) {
      console.error("Error fetching KPI detail:", error);
      toastMessage("Failed to fetch KPI detail", "error");
    } finally {
      setLoadingDetail(false);
    }
  };

  // Status calculation functions - uses dynamic KPI targets from settings
  const getStatusForMissedOpportunities = (value) => {
    // Lower is better for missed opportunities
    if (value <= kpiTargets.missedOpportunities.good) return "good";
    if (value <= kpiTargets.missedOpportunities.average) return "average";
    return "poor";
  };

  const getStatusForPercentage = (value, average, good) => {
    // Higher is better for percentages (e.g., paid conversion)
    if (value >= good) return "good";
    if (value >= average) return "average";
    return "poor";
  };

  const getStatusForOnlineTime = (value, target) => {
    // Calculates percentage of target achieved, uses dynamic thresholds from settings
    const percentage = target > 0 ? (value / target) * 100 : 0;
    if (percentage >= kpiTargets.onlineTime.good) return "good";
    if (percentage >= kpiTargets.onlineTime.average) return "average";
    return "poor";
  };

  // Message functions
  const getMessageForMissedOpportunities = (value) => {
    const status = getStatusForMissedOpportunities(value);
    if (status === "good") return "Excellent! Keep it up!";
    if (status === "average") return "Good, but can improve";
    return "Needs attention";
  };

  const getMessageForPercentage = (value, average, good) => {
    const status = getStatusForPercentage(value, average, good);
    if (status === "good") return "Excellent performance!";
    if (status === "average") return "Good, but can improve";
    return "Needs improvement";
  };

  const getMessageForOnlineTime = (value, target) => {
    const status = getStatusForOnlineTime(value, target);
    if (status === "good") return "Great online presence!";
    if (status === "average") return "Good, but can improve";
    return "Need more online time";
  };

  // Handle KPI click
  const handleKPIClick = (kpiType) => {
    if (selectedKPI === kpiType) {
      setSelectedKPI(null);
      setTableData([]);
      setTotalFilteredItems(0);
    } else {
      setSelectedKPI(kpiType);
      setCurrentPage(1);
      setSearchFilter("");
      setTypeFilter("all");
      setStatusFilter("all");
      setConversionFilter("all");
      setTotalFilteredItems(0);
      fetchKPIDetail(kpiType, 1);
    }
  };

  // Handle close detail
  const handleCloseDetail = () => {
    setSelectedKPI(null);
    setTableData([]);
    setTotalFilteredItems(0);
  };

  // Handle date filter change
  const handleDateFilterChange = (value) => {
    setDateFilter(value);
    setSelectedKPI(null);
    setTableData([]);
    setTotalFilteredItems(0);
    // Reset custom dates when switching away from custom
    if (value !== "custom") {
      setCustomStartDate(null);
      setCustomEndDate(null);
    }
  };

  // Handle custom date changes
  const handleCustomStartDateChange = (date) => {
    setCustomStartDate(date);
    setSelectedKPI(null);
    setTableData([]);
    setTotalFilteredItems(0);
  };

  const handleCustomEndDateChange = (date) => {
    setCustomEndDate(date);
    setSelectedKPI(null);
    setTableData([]);
    setTotalFilteredItems(0);
  };

  // Get unique filter options from current page data
  const getUniqueTypes = () => {
    return [...new Set(tableData.map((item) => item.type).filter(Boolean))];
  };

  const getUniqueStatuses = () => {
    return [...new Set(tableData.map((item) => item.status).filter(Boolean))];
  };

  
  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (selectedKPI) {
      fetchKPIDetail(selectedKPI, page);
    }
  };

  // Fetch KPI targets from settings on mount


  useEffect(() => {
    fetchKPITargets();
  }, []);
  // Fetch KPI data when consultant, date filter, custom dates, or KPI targets change
  // This ensures status calculations use the latest dynamic targets from settings
  useEffect(() => {
    console.log(kpiTargets, "kpiTargets");
    if (consultantId && kpiTargets && Object.keys(kpiTargets).length > 0) {
      // Only fetch if not custom or if custom dates are both set
      if (dateFilter !== "custom" || (customStartDate && customEndDate)) {
        fetchKPIData();
      }
    }
  }, [consultantId, dateFilter, customStartDate, customEndDate, kpiTargets]);

  // Calculate percentage for each KPI based on dynamic targets from settings
  const getMissedOpportunityPercentage = (value, target) => {

    // For missed opportunities, lower is better
    // Conditions:
    // - if value <= good, return 100%
    // - if value between good and average, return 75%
    // - if value between average and poor, return 25%
    // - if value > poor, return 0% (alert condition)
    let achievedPercentage = 0;
    let {good, average, poor} = target;
    let targetValue = (value/poor)*100;

    achievedPercentage = 100-targetValue;
    if(achievedPercentage < 0) {
      achievedPercentage = 0;
    }
    let status="poor";
    if(value <= good) {
      status = "good";
    }
    if(value <= average && value > good) {
      status = "average";
    }
    if(value <= poor && value > average) {
      status = "poor";
    }
    if(value > poor) {
      status = "poor";
    }
    if(value < 0) {
      status = "danger";
    }

    console.log(value, targetValue, achievedPercentage, status, "achievedPercentage, status",target);
    return {achievedPercentage, status};
  };

  const getPaidConversionPercentage = (value,target) => {
    
    let {good, average, poor} = target;
    let status="poor";
   let achievedPercentage = value;
   
    if (achievedPercentage >= good) {
      status = "good";
      // achievedPercentage = 100;
    }
    if (achievedPercentage >= average && achievedPercentage < good) {
      status = "average";
      // achievedPercentage = 75;
    }


    return {achievedPercentage, status};
  };

  const getOnlineTimePercentage = (value, total,target) => {
    // For online time, calculate percentage of target achieved
    // Then map to percentage based on dynamic thresholds
    let {good, average, poor} = target;
    let status="poor";
   let achievedPercentage = (value / total) * 100; 
   
    if (achievedPercentage >= good) {
      status = "good";
      // achievedPercentage = 100;
    }
    if (achievedPercentage >= average && achievedPercentage < good) {
      status = "average";
      // achievedPercentage = 75;
    }
    if (achievedPercentage >= poor && achievedPercentage < average) {
      status = "poor";
      // achievedPercentage = 25;
    }

    console.log(value, target, total, achievedPercentage, status, "values");
    return {achievedPercentage, status};
  };

  
  // Get display value for each KPI
  const getMissedOpportunityDisplayValue = (value) => {
    return value.toString();
  };

  const getPaidConversionDisplayValue = (value) => {
    return `${Math.round(value)}%`;
  };

  const getOnlineTimeDisplayValue = (value) => {
    return `${value}h`;
  };

  // Get total for missed opportunities
  const getMissedOpportunityTotal = () => {
    return 20;
  };

  // Get table headers based on selected KPI
  const getTableHeaders = () => {
    if (selectedKPI === "missedOpportunities") {
      
      return ["Date of Consultation & Time", "User ID", "User Name", "Mobile", "Gender", "Mode", "Type", "Missed by","Status"];
    } else if (selectedKPI === "paidConversion") {
     
      return ["Date of Consultation & Time", "User ID", "User Name", "Mobile", "Gender", "Mode", "Type", "Problem", "Duration of Consultation", "Amount Paid","Status"];

    } else if (selectedKPI === "onlineTime") {
      return ["Date", "Online Time", "Target", "Achievement %", "Sessions"];
    } else if (selectedKPI === "todayOnlineTime") {
      return ["Date", " Date & Time", "Online Time"];
    }
    return [];
  };

  // Render table row
  const renderTableRow = (item, index) => {
    if (selectedKPI === "missedOpportunities") {
      return (
        <tr key={index}>
                                                    <td>
                                                        {
                                                            item?.logs?.find(log => log.callBy === "user")
                                                                ? dateFormat(new Date(item?.logs?.find(log => log.callBy === "user").timestamp))
                                                                : dateFormat(item?.createdAt) || "---"
                                                        }
                                                    </td>
                                                    <td> <Link to={`${USER_DETAIL}/${item?.user_id}`} target="_blank">{item?.userDetails?.userId || "---"}</Link></td>
                                                    <td> <Link to={`${USER_DETAIL}/${item?.user_id}`} target="_blank">{item?.request_form?.firstName || "---"}</Link></td>
                                                    <td>{item?.userDetails?.mobile || "---"}</td>
                                                    <td>
                                                        {item?.request_form?.gender
                                                            ? CapitalizeFirstWord(item?.request_form?.gender)
                                                            : "---"}
                                                    </td>
                                                    <td>{(item?.session_info?.mode) || "---"}</td>
                                                    <td>{item?.coupon?.code === "FREE5MINUTES" ? "Free" : "Paid"}</td>
                                                    <td>
                                                        {
                                                            (() => {
                                                                const missedLog = item.logs?.find(log => log.callStatus === "missed");
                                                                const cancelledLogs = item.logs?.filter(log => log.callStatus === "cancelled");
                                                                const unavailabilityLogs = item.logs?.find(log => log.callStatus === "canceled due to consultant unavailability, calling next consultant and they are busy");
                                                              console.log(missedLog, cancelledLogs, unavailabilityLogs, "logs");
                                                            if(missedLog) {
                                                                return "Missed by Consultant";
                                                            }
                                                            else if(cancelledLogs && cancelledLogs.length > 0) {

                                                                return "Cancelled by Consultant";
                                                            }
                                                            else if(unavailabilityLogs) {
                                                                return "Canceled due to Consultant Unavailability/ Busy";
                                                            }
                                                            return "Unknown";
                                                            })()
                                                        }

                                                    </td>
                                                   
                                                    <td>{item?.status}
                                                    </td>

        </tr>
      );
    } else if (selectedKPI === "paidConversion") {
      return (
        <tr key={index}>
        <td>
            {
                item?.logs?.find(log => log.callBy === "user")
                    ? dateFormat(new Date(item?.logs?.find(log => log.callBy === "user").timestamp))
                    : dateFormat(item?.createdAt) || "---"
            }
        </td>
        <td> <Link to={`${USER_DETAIL}/${item?.user_id}`} target="_blank">{item?.userDetails?.userId || "---"}</Link></td>
        <td> <Link to={`${USER_DETAIL}/${item?.user_id}`} target="_blank">{item?.request_form?.firstName || "---"}</Link></td>
        <td>{item?.userDetails?.mobile || "---"}</td>
        <td>
            {item?.request_form?.gender
                ? CapitalizeFirstWord(item?.request_form?.gender)
                : "---"}
        </td>
        <td>{(item?.session_info?.mode) || "---"}</td>
        <td>{item?.coupon?.code === "FREE5MINUTES" ? "Free" : "Paid"}</td>
        <td>{item?.request_form?.concern || "---"}</td> 
                                                    <td>{formatDuration(item?.onCompletion?.callDurationInSeconds) || "---"}</td>
                                                    <td>{item?.onCompletion?.amountToDeduct.toFixed(2) || "---"}</td>
       
        <td>{item?.status}
        </td>

</tr>
      );
    } else if (selectedKPI === "onlineTime") {
      return (
        <tr key={index}>
          <td>{item.date || "-"}</td>
          <td>{item.onlineTime || 0}h</td>
          <td>{item.targetOnlineTime || 0}h</td>
          <td>{item.achievementPercentage || 0}%</td>
          <td>{item.sessions || 0}</td>
        </tr>
      );
    } else if (selectedKPI === "todayOnlineTime") {
      return (
        <tr key={index}>
          <td>{item.day || "-"}</td>
          <td>{dateFormat(new Date(item.at)) || "-"}</td>
          <td>{formatDuration(item.totalTime) || 0}</td>
       
        </tr>
      );
    }
    return null;
  };

  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <div className="user_detail_heading">
              <Link
                className="back_icon"
                to={`/consultant-management/consultant-detail/${consultantId}`}
              >
                <IconButton>
                  <ArrowBackIosNewIcon className="back_button" />
                </IconButton>
              </Link>
              <h4 className="Title">KPI Dashboard - {consultantName}</h4>
            </div>
          </div>

          <div style={{ padding: "20px" }}>
            {/* Date Filter */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                marginBottom: "30px",
                borderBottom: "2px solid #e0e0e0",
                paddingBottom: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                {dateFilterOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => handleDateFilterChange(option.value)}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "8px",
                      border: "2px solid",
                      borderColor:
                        dateFilter === option.value ? "#1976d2" : "#e0e0e0",
                      backgroundColor:
                        dateFilter === option.value ? "#1976d2" : "white",
                      color: dateFilter === option.value ? "white" : "#333",
                      cursor: "pointer",
                      fontWeight: dateFilter === option.value ? "600" : "400",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
              {dateFilter === "custom" && (
                <div
                  style={{
                    display: "flex",
                    gap: "15px",
                    alignItems: "center",
                    flexWrap: "wrap",
                    padding: "15px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    <label style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}>
                      Start Date
                    </label>
                    <DatePicker
                      selected={customStartDate}
                      onChange={handleCustomStartDateChange}
                      maxDate={customEndDate || new Date()}
                      placeholderText="Select Start Date"
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    <label style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}>
                      End Date
                    </label>
                    <DatePicker
                      selected={customEndDate}
                      onChange={handleCustomEndDateChange}
                      minDate={customStartDate}
                      maxDate={new Date()}
                      placeholderText="Select End Date"
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              )}
            </div>

            {/* KPI Circular Progress Indicators */}
              
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "40px",
                marginBottom: "50px",
                flexWrap: "wrap",
                padding: "30px",
              }}
            >
              {/* Missed Opportunity */}
              <CircularProgressKPI
                value={kpiData.missedOpportunities.value}
                status={kpiData?.missedOpportunities?.status}
                title="Missed Opportunity"
                onClick={() => handleKPIClick("missedOpportunities")}
                kpiType="missedOpportunities"
                percentage={kpiData?.missedOpportunities?.percentage}
                showDangerIcon={kpiData?.missedOpportunities?.value > kpiTargets?.missedOpportunities?.poor}
              />

              {/* Paid Conversion */}
              <CircularProgressKPI
                value={kpiData.paidConversion.value}
                percentage={kpiData?.paidConversion?.percentage}
                status={kpiData?.paidConversion?.status}
                title="Paid Conversion"
                onClick={() => handleKPIClick("paidConversion")}
                kpiType="paidConversion"
              />

              {/* Online Time */}
              {/* <CircularProgressKPI
                value={getOnlineTimeDisplayValue(kpiData.onlineTime.value)}
                percentage={getOnlineTimePercentage(
                  kpiData.onlineTime.value,
                  kpiData.onlineTime.target
                )}
                status={kpiData.onlineTime.status}
                title="Online Time"
                onClick={() => handleKPIClick("onlineTime")}
                kpiType="onlineTime"
                total={`${kpiData.onlineTime.target}h`}
              /> */}

              {/* Today's Online Time */}
              <CircularProgressKPI
                value={kpiData?.todayOnlineTime?.value}
                percentage={kpiData?.todayOnlineTime?.percentage}
                status={kpiData?.todayOnlineTime?.status}
                title="Today's Online Time"
                onClick={() => handleKPIClick("todayOnlineTime")}
                kpiType="todayOnlineTime"
              />
            </div>

            <ConsultantOnlineTime consultantId={consultantId} />

            {/* KPI Detail Table Section */}
            {selectedKPI && (
              <div style={{ marginTop: "30px", padding: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h4 style={{ margin: 0 }}>
                    {selectedKPI === "missedOpportunities"
                      ? "Missed Opportunity Details"
                      : selectedKPI === "paidConversion"
                      ? "Paid Conversion Details"
                      : selectedKPI === "todayOnlineTime"
                      ? "Today's Online Time Details"
                      : "Online Time Details"}
                  </h4>
                  <button
                    onClick={handleCloseDetail}
                    style={{
                      padding: "8px 16px",
                      backgroundColor: "#f44336",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Close
                  </button>
                </div>

                {loadingDetail ? (
                  <Loader />
                ) : tableData.length > 0 ? (
                  <>
                    {/* Filters */}
                  

                    {/* Table */}
                    {
                      selectedKPI === "todayOnlineTime" && (
                        <div style={{ 
                          marginBottom: "20px", 
                          padding: "15px 20px",
                          backgroundColor: "#f5f5f5",
                          borderRadius: "8px",
                          border: "1px solid #e0e0e0"
                        }}>
                          <div style={{ 
                            display: "flex", 
                            alignItems: "center", 
                            gap: "10px",
                            flexWrap: "wrap"
                          }}>
                            <span style={{ 
                              fontSize: "16px", 
                              fontWeight: "600",
                              color: "#333"
                            }}>
                              Average Achievement:
                            </span>
                            <span style={{ 
                              fontSize: "18px", 
                              fontWeight: "700",
                              color: kpiData?.todayOnlineTime?.status === "good" ? "#4caf50" :
                                     kpiData?.todayOnlineTime?.status === "average" ? "#ff9800" : "#f44336"
                            }}>
                              {kpiData?.todayOnlineTime?.percentage?.toFixed(2) || 0}%
                            </span>
                            <span style={{ 
                              fontSize: "14px", 
                              color: "#666"
                            }}>
                              ({kpiData?.todayOnlineTime?.value || 0}h / {kpiData?.todayOnlineTime?.total || 0}h target)
                            </span>
                          </div>
                        </div>
                      )
                    }
                    <div style={{ overflowX: "auto" }}>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {getTableHeaders().map((header, index) => (
                              <th key={index}>{header}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((item, index) => renderTableRow(item, index))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    {totalFilteredItems > pageLimit && (
                      <div className="Pagination" style={{ 
                        marginTop: "20px", 
                        display: "flex",
                        justifyContent: "center"
                      }}>
                        <Pagination
                          activePage={currentPage}
                          itemsCountPerPage={pageLimit}
                          totalItemsCount={totalFilteredItems}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          itemClass="page-item"
                          linkClass="page-link"
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div style={{ padding: "40px", textAlign: "center" }}>
                    <p>No data available for the selected KPI</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsultantKPI;

